import { render } from "./Sidebar.vue?vue&type=template&id=9a04c124&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=9a04c124&lang=scss&scoped=true"

import exportComponent from "/root/workspace/public_sso_CS39/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a04c124"]])

export default __exports__